module.exports = __webpack_public_path__ + "img/banner4-2.3c998eb0.png";